import { render } from "./application_reduction_info.vue?vue&type=template&id=c47750cc&scoped=true"
import script from "./application_reduction_info.vue?vue&type=script&lang=js"
export * from "./application_reduction_info.vue?vue&type=script&lang=js"

import "./application_reduction_info.vue?vue&type=style&index=0&id=c47750cc&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c47750cc"],['__file',"vue/js/components/sale/applications/inside/reduction/application_reduction_info.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c47750cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c47750cc', __exports__)) {
    console.log('reload')
    api.reload('c47750cc', __exports__)
  }
  
  module.hot.accept("./application_reduction_info.vue?vue&type=template&id=c47750cc&scoped=true", () => {
    console.log('re-render')
    api.rerender('c47750cc', render)
  })

}


export default __exports__